import { get } from '@/lib/request/webapp/http';
import { getObjConfig } from '@webapp-next/lib/session';

export default function userHasPermission(permissionKey = '') {
  return (getObjConfig()?.Me?.Permissions || []).includes(permissionKey);
}

export async function loadUserPermissions() {
  if (!getObjConfig()?.Me) {
    const { data } = await get(`api/v1/me`);

    window.$dt = window.$dt || {};
    window.$dt.objConfig = window.$dt.objConfig || {};
    window.$dt.objConfig.Me = data;
  }
}
